import { WorkspaceState } from "@/contexts/TenantContext";

class LocalStorageWorkspacesAndTenantMemberships {
  private prefix = "WorkspacesAndTenantMemberships__";
  private workspaceState = "WorkspaceState";

  constructor() {}

  public putWorkspaceState(ws: WorkspaceState) {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(this.prefix + this.workspaceState, JSON.stringify(ws));
  }

  public getWorkspacesState(): WorkspaceState | undefined {
    if (typeof localStorage === "undefined") return;
    const stateString = localStorage.getItem(this.prefix + this.workspaceState);
    if (stateString) {
      return JSON.parse(stateString);
    }
    return undefined;
  }

  public clearState() {
    if (typeof localStorage === "undefined") return;
    localStorage.removeItem(this.prefix + this.workspaceState);
  }
}

export default new LocalStorageWorkspacesAndTenantMemberships();
